import { MrAccordion } from '@mrhenry/wp--mr-interactive';

class CAW_Accordion extends MrAccordion {
	override handleToggleEvent( trigger: Element, onlyOpen: boolean ): boolean {
		const result = super.handleToggleEvent( trigger, onlyOpen );

		if ( trigger.getAttribute( 'aria-expanded' ) === 'true' ) {
			trigger.closest( '.accordion__item' )?.setAttribute( 'data-is-expanded', '' );
		} else {
			trigger.closest( '.accordion__item' )?.removeAttribute( 'data-is-expanded' );
		}

		return result;
	}
}

customElements.define( 'mr-accordion', CAW_Accordion );
